import { getSeriesPageTitle, $loader } from './_helpers';
import {
	disableModuleSlickSlider,
	initModuleSlickSlider,
	setModuleSlickSliders
} from './../_slider';
import initSelect from './../_select';

let $seriesContent;

const initSeriesContent = function () {
	$seriesContent = $('#series-content');

	if ($seriesContent.length) {
		// Series tab ajax upload
		if ($('.ren-hero__menu-link').length) {
			// Tabs checkout by AJAX on series landing page
			$('.ren-hero__menu-link').on('click', function (e) {
				e.preventDefault();
				const tabType = $(this).attr('id');
				const postID = $(this).closest('.ren-series').data('post-id');

				$('.ren-hero__menu-link').removeClass('active');
				$(this).addClass('active');

				// Get translated tab name for use it on HTML <title>
				const currentPageTabName = $(this).html();
				$.ajax({
					type: 'GET',
					url: WPvars.paths.ajaxURL,
					data: {
						action: 'series-tabs',
						tab: tabType,
						post_id: postID,
						security: WPvars.nonce
					},
					beforeSend() {
						$loader.addClass('active');
					},
					success(data) {
						$loader.removeClass('active');
						if (data) {
							reInitSliders(data);

							let title = document.title;
							let url = $('.series-hero-block').data('url');
							if (tabType === 'tab-main') {
								//Actual only for main page
								$('#main-series').addClass('tab-main-series');
								title = title.split('?')[0];
							} else {
								$('#main-series').removeClass(
									'tab-main-series'
								);
								title = getSeriesPageTitle(currentPageTabName);
								url += '?tab=' + tabType.replace('tab-', '');
							}

							//Update title
							document.title = title;

							// For security reasons, pushState() will not update the URL if it includes a domain,
							// so we're using regex to keep only the path, e.g. /managers/P4.
							const path = url.replace(/https?:\/\/[^\/]+/i, '');
							// Push this page onto the browser history stack for forward/back button functionality.
							history.pushState({}, title, path);

							// Scroll to TOP
							$('html, body').animate({ scrollTop: 0 }, 'fast');
						} else {
							// eslint-disable-next-line no-console
							console.warn('Fail');
							$seriesContent.html('');
						}
					},
					error() {
						$loader.removeClass('active');
						// eslint-disable-next-line no-console
						console.warn('Fail');
					}
				});
			});
		}

		// Single blog ajax upload
		$seriesContent.on('click', '.ren-blog__item a', function (e) {
			e.preventDefault();
			const $mainBlock = $(this).closest('.ren-blog__item');
			//Get slug for search
			const blogSlug = $mainBlock.data('slug');
			$.ajax({
				type: 'GET',
				url: WPvars.paths.ajaxURL,
				data: {
					action: 'blog-single',
					blog: blogSlug,
					security: WPvars.nonce
				},
				beforeSend() {
					$loader.addClass('active');
				},
				success(data) {
					$loader.removeClass('active');
					if (data !== '0') {
						$seriesContent.html(data);

						//Update title
						let title = document.title;
						title = getSeriesPageTitle('Blog');
						document.title = title;

						// For security reasons, pushState() will not update the URL if it includes a domain,
						// so we're using regex to keep only the path, e.g. /managers/P4.
						let url = $('.series-hero-block').data('url');
						url += '?tab=blog&blog=' + blogSlug;
						const path = url.replace(/https?:\/\/[^\/]+/i, '');

						// Push this page onto the browser history stack for forward/back button functionality.
						history.pushState({}, title, path);

						// Scroll to TOP
						$('html, body').animate({ scrollTop: 0 }, 'fast');
					} else {
						// eslint-disable-next-line no-console
						console.warn('Fail');
						$seriesContent.html('');
					}
				},
				error() {
					$loader.removeClass('active');
					// eslint-disable-next-line no-console
					console.warn('Fail');
				}
			});
		});

		// Single video ajax upload
		$seriesContent.on('click', '.ren-video-item a', function (e) {
			e.preventDefault();
			//Get slug for search
			const videoSlug = $(this).closest('.ren-video-item').data('slug');
			$.ajax({
				type: 'GET',
				url: WPvars.paths.ajaxURL,
				data: {
					action: 'video-single',
					videos: videoSlug,
					security: WPvars.nonce
				},
				beforeSend() {
					$loader.addClass('active');
				},
				success(data) {
					$('#main-series').removeClass('tab-main-series');
					$loader.removeClass('active');
					if (data !== '0') {
						reInitSliders(data);

						//Update title
						let title = document.title;
						title = getSeriesPageTitle('Video');
						document.title = title;

						// For security reasons, pushState() will not update the URL if it includes a domain,
						// so we're using regex to keep only the path, e.g. /managers/P4.
						let url = $('.series-hero-block').data('url');
						url += '?videos=' + videoSlug;
						const path = url.replace(/https?:\/\/[^\/]+/i, '');

						// Push this page onto the browser history stack for forward/back button functionality.
						history.pushState({}, title, path);

						// Scroll to TOP
						$('html, body').animate({ scrollTop: 0 }, 'fast');
					} else {
						// eslint-disable-next-line no-console
						console.warn('Fail');
						$seriesContent.html('');
					}
				},
				error() {
					$loader.removeClass('active');
					// eslint-disable-next-line no-console
					console.warn('Fail');
				}
			});
		});

		// Single Cast ajax upload
		$seriesContent.on('click', '.cast-link', function (e) {
			e.preventDefault();
			//Get slug for search
			let castSlug = $(this).data('slug');

			if (!castSlug) {
				// Use character link for current actor, as we don't have an actor page
				const character = $(this).data('character');
				const $castLink = $('.cast-items').find('#' + character);

				if ($castLink.length) {
					castSlug = $castLink.data('slug');
				} else {
					// eslint-disable-next-line no-console
					console.warn('Character not found');
					return;
				}
			}

			$.ajax({
				type: 'GET',
				url: WPvars.paths.ajaxURL,
				data: {
					action: 'cast-single',
					cast: castSlug,
					security: WPvars.nonce
				},
				beforeSend() {
					$loader.addClass('active');
				},
				success(data) {
					$('#main-series').removeClass('tab-main-series');
					$loader.removeClass('active');
					if (data !== '0') {
						reInitSliders(data);

						//Update title
						let title = document.title;
						title = getSeriesPageTitle('Cast');
						document.title = title;

						// For security reasons, pushState() will not update the URL if it includes a domain,
						// so we're using regex to keep only the path, e.g. /managers/P4.
						let url = $('.series-hero-block').data('url');
						url += '?tab=cast&cast=' + castSlug;
						const path = url.replace(/https?:\/\/[^\/]+/i, '');

						// Push this page onto the browser history stack for forward/back button functionality.
						history.pushState({}, title, path);

						// Scroll to TOP
						$('html, body').animate({ scrollTop: 0 }, 'fast');
					} else {
						// eslint-disable-next-line no-console
						console.warn('Fail');
						$seriesContent.html('');
					}
				},
				error() {
					$loader.removeClass('active');
					// eslint-disable-next-line no-console
					console.warn('Fail');
				}
			});
		});

		$seriesContent.on('click', '.cast-tab input', function () {
			const $castTab = $('.cast-items');
			const $crewTab = $('.crew-items');
			if ($(this).attr('id') === 'cast-tab') {
				$castTab.show();
				$crewTab.hide();
			}
			if ($(this).attr('id') === 'crew-tab') {
				$crewTab.show();
				$castTab.hide();
			}
		});

		// Episode list checkout

		$seriesContent.on('click', '.episode-item', function (e) {
			e.preventDefault();
			const episodeSlug = $(this).data('episode-slug');
			$('.single-episode-block:not([class*="hidden"]').addClass('hidden');
			$(
				".single-episode-block[data-episode-slug='" + episodeSlug + "']"
			).removeClass('hidden');
			$('.episode-related-videos:not([class*="hidden"]').addClass(
				'hidden'
			);
			$(
				".episode-related-videos[data-episode-slug='" +
					episodeSlug +
					"']"
			).removeClass('hidden');
			$(
				".episode-related-videos[data-episode-slug='" +
					episodeSlug +
					"']"
			)
				.find('.ren-posts-slider__list')
				.get(0)
				.slick.setPosition();
			const url = new URL(window.location.href);
			url.searchParams.set('episode', episodeSlug);
			history.pushState({}, document.title, url.href);
		});

		$seriesContent.on(
			'click',
			'.ren-episode_guide-navigation .ren-select__item',
			function () {
				const $seasonPicker = $(this).closest('.ren-select');
				const $episodeSlider = $(this).closest('.ren-posts-slider');
				const currentSeason = $(this).text();
				$seasonPicker
					.find('.ren-select__item--selected')
					.removeClass('ren-select__item--selected');
				$(this).addClass('ren-select__item--selected');
				$seasonPicker.find('.ren-select__current').text(currentSeason);
				$episodeSlider
					.find('.ren-episode_season-block:not([class*="hidden"])')
					.addClass('hidden');
				const $currentSeasonSlider = $episodeSlider.find(
					".ren-episode_season-block[data-season='" +
						currentSeason +
						"']"
				);
				$currentSeasonSlider.removeClass('hidden');
				// Reset slick view
				if (
					$currentSeasonSlider.find('.ren-posts-slider__list').get(0)
				) {
					$currentSeasonSlider
						.find('.ren-posts-slider__list')
						.get(0)
						.slick.setPosition();
				}
			}
		);
	}
};

const reInitSliders = function (data) {
	// Re-init sliders
	disableModuleSlickSlider();
	$seriesContent.html(data);
	setModuleSlickSliders();
	initModuleSlickSlider();
	initSelect();
};

export default initSeriesContent;
